import React, { useState, useEffect } from 'react'
import swal from 'sweetalert';
import Select from 'react-select';
import Axios from "axios"

export default function Change(props) {
   
    const [items, setitems] = useState({  password: "", repassword: "", company_id: props.companyid, userid: 0 })
    useEffect(() => {
       
    }, [])
    
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setitems({ ...items, [name]: value })
    }
    const refresh = () => {
       
        setitems({ password: "", repassword: "", company_id: props.companyid, userid: 0 });
    }
    const savemethod = async (data) => {
        const url = process.env.REACT_APP_APIURL + "User/Change";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Password Change Successfully",
                    icon: "success"
                })
                refresh();

            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const submitButton = e.target.querySelector('button[type="submit"]');
        submitButton.disabled = true;
        submitButton.innerHTML = '<section><span class="loader-5"></span></section>';
      
        try {
          if (items.password === "") {
            swal({
              title: "New Password Required!",
              icon: "error"
            });
            // Enable the submit button
            submitButton.disabled = false;
            // Reset the button text
            submitButton.innerHTML = "Submit";
            return;
          }
      
          if (items.repassword !== items.password) {
            swal({
              title: "Password and Confirm Password do not match!",
              icon: "error"
            });
            // Enable the submit button
            submitButton.disabled = false;
            // Reset the button text
            submitButton.innerHTML = "Submit";
            return;
          }
      
          items.userid = localStorage.getItem("userid");
      
          await savemethod(items);
          // Reset the form
          // ...
      
          // Show success message
          swal({
            title: "Form submitted successfully!",
            icon: "success"
          });
        } catch (error) {
          // Show error message
          swal({
            title: "An error occurred!",
            text: error.message,
            icon: "error"
          });
        } finally {
          // Enable the submit button
          submitButton.disabled = false;
          // Reset the button text
          submitButton.innerHTML = "Submit";
        }
      };
    return (
        <div className="row">
            <div className="col-12 col-md-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-3 mt-5 text-center mx-auto">Change Password</h3>
                    </div>
                    <div className="card-body">

                        <div className="basic-form">
                            <form action="" onSubmit={handleSubmit}>
                                <div className="row flex-column align-items-center">
                                    
                                   
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">New Passoword *</label>
                                        <input type="text" className="form-control" name="password" autoComplete="off" value={items.password} onChange={handleInput} required />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">Confirm Passoword *</label>
                                        <input type="text" className="form-control" name="repassword" autoComplete="off" value={items.repassword} onChange={handleInput} required />
                                    </div>
                                 
                                </div>
                                <button type="submit" className="d-flex mx-auto btn btn-primary">Save</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}